import { Colors, getPrice } from '@sigma-frontend-libs/commons'

import { icons, services } from '@/utils'

import sticker from '@/components/sticker'

// NOTE: валюта this.currency идёт из миксина balance
// там это значение указано в props
export default function(h) {
  return h(
    sticker,
    {
      props: {
        value: getPrice(this.balance, { currency: this.currency }),
        label: this.getTranslate(`${services.invoices}.labels.balance`),
        loading: this.balanceLoading,
        color: Colors.grey,
        iconSVG: this.currency,
        button: {
          icon: icons.refresh,
          color: Colors.grey,
          tooltip: this.getTranslate(`${services.invoices}.tooltips.balance`),
          loading: this.balanceLoading,
          disabled: this.balanceLoading,
          callback: () => {
            return this.getBalance()
          }
        }
      }
    }
  )
}
